<app-crud-table
  heading="Models"
  itemTypeName="Model"
  [items]="items"
  [columns]="columns"
  [loading]="loading"
  [showDefaultItemBadge]="false"
  (toggle)="toggle($event)"
  (delete)="delete($event)"
  (showItemDialog)="onShowItemDialog($event)"
></app-crud-table>

<p-dialog
  [(visible)]="showItemDialog"
  [header]="getDialogHeader()"
  [style]="{ width: '65%' }"
  [modal]="true"
  (onHide)="onModelDialogCancel()"
>
  <app-model-dialog
    *ngIf="showItemDialog"
    [editedItem]="clonedItem"
    [processing]="processing$ | async"
    (onAddModel)="handleAddModel($event)"
    (onEditModel)="handleEditModel($event)"
    (onCancel)="onModelDialogCancel()"
  ></app-model-dialog>
</p-dialog>

<ng-template #booleanTemplate let-item="item" let-field="field">
  <i *ngIf="item[field]; else timesTemplate" class="pi pi-check"></i>
</ng-template>

<ng-template #timesTemplate>
  <i  class="pi pi-times"></i>
</ng-template>

<ng-template #roleTemplate  let-item="item">
  <div class="d-flex flex-column">
    @for (role of item.rolesRestriction ; track role) {
      <div>{{role}}</div>
    }
  </div>
</ng-template>
